import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@/styles/responsive.css';
import '@/styles/no-scroll.css';
import '@/styles/rtl.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
